module.exports = __webpack_public_path__ + "static/media/Glow.6d66f02b.png";